<template>
  <div class="setting_box">
    <titleSeeting :active="active" class="setting" />
    <div>
      <!--参数设置-->
      <div class="first">
        <div class="title"><span class="circle" />随机基本参数</div>
        <div class="detail">
          <el-row class="item">
            <el-col :span="12">
              <el-row>
                <el-col :span="6" class="right">
                  <span>
                    <img
                      src="../../assets/avatar/require.png"
                      alt
                      width="6px;"
                    />
                  </span>
                  是否设置样本量：
                </el-col>
                <el-col :span="18" class="rights">
                  <el-radio-group
                    v-model="is_need_sample_size"
                    @change="handelIsSample"
                    :disabled="isLock || is_use_blind || envStatus"
                  >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="4" class="right" style="text-align: left"
                  >样本量：</el-col
                >
                <el-col :span="8">
                  <el-input
                    v-model="sample_size"
                    size="mini"
                    style="width: 100%"
                    :disabled="disabledInput || isLock"
                    onkeyup="this.value = this.value.replace(/[^\d.]/g,'')"
                    type="number"
                    @mousewheel.native.prevent
                  />
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="sample_size_type"
                    size="mini"
                    placeholder="请选择"
                    :disabled="isLock || disabledInput || is_use_blind"
                  >
                    <el-option
                      v-for="(item, n) in numNameList"
                      :key="n"
                      :label="item"
                      :value="item"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="item">
            <el-col :span="12">
              <el-row>
                <el-col :span="6" style="text-align: right" class="right">
                  <img src="../../assets/avatar/require.png" alt width="6px;" />
                  盲态设置：
                </el-col>
                <el-col :span="18">
                  <el-select
                    v-model="blind_type"
                    size="mini"
                    placeholder="请选择"
                    :disabled="isLock || is_use_blind || envStatus"
                    @change="handleBlindTtype"
                  >
                    <el-option
                      v-for="(item, s) in blindList"
                      :key="s"
                      :label="item"
                      :value="item"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col v-if="isShowBind" :span="12">
              <el-row>
                <el-col :span="4" class="right" style="text-align: left"
                  >揭盲负责人：</el-col
                >
                <el-col :span="8">
                  <el-select
                    v-model="unblind_user_id"
                    style="width: 100%"
                    size="mini"
                    placeholder="请选择"
                    :disabled="isLock || is_use_blind"
                  >
                    <el-option
                      v-for="(item, a) in blindData"
                      :key="a"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="item">
            <el-col :span="3" class="right">
              <img src="../../assets/avatar/require.png" alt width="6px;" />
              试验设计：
            </el-col>
            <el-col :span="21" class="rights">
              <el-select
                v-model="experimental_design"
                placeholder="请选择"
                size="mini"
                :disabled="isLock || is_use_blind || envStatus"
              >
                <el-option
                  v-for="(item, x) in designList"
                  :key="x"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-col>
          </el-row>
          <el-row class="item">
            <el-col :span="12">
              <el-row>
                <el-col :span="6" class="right">
                  <img src="../../assets/avatar/require.png" alt width="6px;" />
                  随机类型：
                </el-col>
                <el-col :span="18" class="rights">
                  <el-select
                    v-model="random_type"
                    placeholder="请选择"
                    size="mini"
                    :disabled="isLock || is_use_blind || envStatus"
                    @change="handelType"
                  >
                    <el-option
                      v-for="(item, m) in randomTypeList"
                      :key="m"
                      :label="item.name"
                      :value="item.name"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="6" class="right">
                  <img src="../../assets/avatar/require.png" alt width="6px;" />
                  随机种子：
                </el-col>
                <el-col :span="8">
                  <el-input
                    v-model="random_seed"
                    size="mini"
                    :disabled="isLock || is_use_blind"
                    type="number"
                    onkeyup="this.value = this.value.replace(/[^\d.]/g,'')"
                    @mousewheel.native.prevent
                  />
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
      <!--静态随机参数-->
      <div v-if="staticShow" class="two">
        <div class="title"><span class="circle" />静态随机参数</div>
        <el-row class="detail">
          <el-col :span="3" class="right">
            <img src="../../assets/avatar/require.png" alt width="6px;" />
            区段使用：
          </el-col>
          <el-col :span="18" class="rights">
            <el-select
              v-model="section_type"
              placeholder="请选择"
              size="mini"
              :disabled="isLock || is_use_blind || envStatus"
            >
              <el-option
                v-for="(item, i) in typeList"
                :key="i"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-col>
        </el-row>
      </div>
      <!--动态随机参数-->
      <div v-if="dynamicShow" class="three two">
        <div class="title"><span class="circle" />动态随机参数</div>
        <div class="detail">
          <el-row class="threes">
            <el-row>
              <el-col :span="3" class="right">
                <img src="../../assets/avatar/require.png" alt width="6px;" />
                一级偏差阈值：
              </el-col>
              <el-col :span="6">
                <el-input
                  v-model="one_offset"
                  size="mini"
                  type="number"
                  :disabled="isLock || is_use_blind || envStatus"
                  @mousewheel.native.prevent
                />
              </el-col>
            </el-row>
            <el-row class="desc">
              <el-col>(允许整个项目各试验组的一级最大偏差值)</el-col>
            </el-row>
          </el-row>
          <el-row class="threes">
            <el-row>
              <el-col :span="3" class="right">
                <img src="../../assets/avatar/require.png" alt width="6px;" />
                一级修正概率：
              </el-col>
              <el-col :span="6">
                <el-input
                  v-model="one_probability"
                  size="mini"
                  type="number"
                  :disabled="isLock || is_use_blind || envStatus"
                  @mousewheel.native.prevent
                />
              </el-col>
            </el-row>
            <el-row class="desc">
              <el-col>(入组整个项目最小组的概率，一般为小于100%)</el-col>
            </el-row>
          </el-row>
          <el-row class="threes">
            <el-row>
              <el-col :span="3" class="right">
                <img src="../../assets/avatar/require.png" alt width="6px;" />
                二级偏差阈值：
              </el-col>
              <el-col :span="6">
                <el-input
                  v-model="two_offset"
                  size="mini"
                  type="number"
                  :disabled="isLock || is_use_blind || envStatus"
                  @mousewheel.native.prevent
                />
              </el-col>
            </el-row>
            <el-row class="desc">
              <el-col>(允许整个项目各试验组的二级最大偏差值)</el-col>
            </el-row>
          </el-row>
          <el-row class="threes">
            <el-row>
              <el-col :span="3" class="right">
                <img src="../../assets/avatar/require.png" alt width="6px;" />
                二级修正概率：
              </el-col>
              <el-col :span="6">
                <el-input
                  v-model="two_probability"
                  size="mini"
                  :disabled="isLock || is_use_blind || envStatus"
                  type="number"
                  @mousewheel.native.prevent
                />
              </el-col>
            </el-row>
            <el-row class="desc">
              <el-col>(入组整个项目最小组的概率，一般为100%)</el-col>
            </el-row>
          </el-row>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button
        v-preventReClick
        size="mini"
        style="width: 100px"
        type="primary"
        @click="goParameter()"
        >下一步</el-button
      >
    </div>
  </div>
</template>

<script>
import titleSeeting from "./component/titleSeeting";
import { allUserList } from "@/api/proUser";
import { detailPro } from "@/api/platform";
import { baseSet } from "@/api/random";
import {
  getProjectId,
  getProStatus,
  setBlind,
  setRandom,
  setSection,
} from "@/utils/auth";

export default {
  name: "Random",
  components: {
    titleSeeting,
  },
  data() {
    return {
      proStatus: "", // 项目状态
      active: 1,
      is_need_sample_size: true, // 是否需要样本量
      sample_size: null, // 样本量
      sample_size_type: "", // 样本量类型
      blind_type: "双盲", // 盲态设置
      unblind_user_id: "", // 揭盲负责人
      experimental_design: "交叉设计", // 试验设计
      random_type: "静态随机", // 随机类型
      random_seed: null, // 随机种子
      section_type: "竞争区段", // 区段使用
      one_offset: null, // 一级偏差阈值
      one_probability: null, // 一级修正概率
      two_offset: null, // 二级偏差阈值:
      two_probability: null, // 二级修正概率
      isShowBind: true, // 是否显示揭盲负责人
      disabledInput: false,
      numName: "所有入组病例",
      numNameList: [
        "所有入组病例",
        "除脱落以外病例",
        "除破盲以外病例",
        "除脱落与破盲以外的病例",
      ],
      blindList: ["双盲", "单盲", "开放"],
      typeList: [{ name: "竞争区段" }, { name: "分配区段" }],
      randomTypeList: [{ name: "静态随机" }, { name: "动态随机" }],
      designList: [
        { name: "平行设计" },
        { name: "交叉设计" },
        { name: "适应设计" },
      ],
      blindValue: "双盲",
      staticShow: true, // 静态
      dynamicShow: false, // 动态
      proId: "",
      blindData: [],
      basicId: "", // 基本参数设置的id
      is_use_blind: false,
      isLock: false, // 锁定项目不可编辑
      envStatus: false,
    };
  },
  created() {
    if (sessionStorage.getItem("iwrs_environment") === "PROD") {
      this.envStatus = true;
    }
    this.proId = getProjectId();
    this.getList();
    this.getDetail();
    this.proStatus = getProStatus();
  },
  methods: {
    // 页面初始化进来查询详情
    getDetail() {
      detailPro({ id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data.status === "项目已锁定") {
              this.isLock = true;
            } else {
              this.isLock = false;
            }
            this.is_use_blind=Boolean(res.data.status !== "项目创建中")
            this.is_need_sample_size = res.data.is_need_sample_size;
            if (this.is_need_sample_size) {
              this.disabledInput = false;
            } else {
              this.disabledInput = true;
            }
            this.sample_size_type = res.data.sample_size_type;
            if (res.data.sample_size === 0) {
              this.sample_size = "";
            } else {
              this.sample_size = res.data.sample_size;
            }
            this.blind_type = res.data.blind_type;
            if (
              res.data.blind_type === "单盲" ||
              res.data.blind_type === "开放"
            ) {
              this.isShowBind = false;
            } else {
              this.isShowBind = true;
            }
            this.unblind_user_id = res.data.unblind_user_id;
            this.experimental_design = res.data.experimental_design;
            this.random_type = res.data.random_type;
            if (this.random_type === "静态随机") {
              this.staticShow = true;
              this.dynamicShow = false;
            } else {
              this.staticShow = false;
              this.dynamicShow = true;
            }
            if (res.data.random_seed === 0) {
              this.random_seed = "";
            } else {
              this.random_seed = res.data.random_seed;
            }
            this.section_type = res.data.section_type;
            if (res.data.one_offset === 0) {
              this.one_offset = "";
            } else {
              this.one_offset = res.data.one_offset;
            }
            if (res.data.one_probability === 0) {
              this.one_probability = "";
            } else {
              this.one_probability = res.data.one_probability;
            }
            if (res.data.two_offset === 0) {
              this.two_offset = "";
            } else {
              this.two_offset = res.data.two_offset;
            }
            if (res.data.two_probability === 0) {
              this.two_probability = "";
            } else {
              this.two_probability = res.data.two_probability;
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => [console.log(res.msg)]);
    },
    // 揭盲负责人
    getList() {
      allUserList({ project_id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.blindData = res.data.map((item) => {
                const obj = {};
                obj.name = item.name;
                obj.id = item.id;
                return obj;
              });
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.smg);
        });
    },
    // 样本量
    handelIsSample(val) {
      console.log(val);
      if (val) {
        this.disabledInput = false;
      } else {
        this.disabledInput = true;
        this.sample_size_type = "";
        this.sample_size = null;
      }
    },
    // 随机类型
    handelType(val) {
      console.log(val);
      if (val === "静态随机") {
        this.staticShow = true;
        this.dynamicShow = false;
        this.one_offset = null; // 一级偏差阈值
        this.one_probability = null; // 一级修正概率
        this.two_offset = null; // 二级偏差阈值:
        this.two_probability = null; // 二级修正概率
      } else {
        this.staticShow = false;
        this.dynamicShow = true;
        this.section_type = "";
      }
    },
    // 盲态设置
    handleBlindTtype(val) {
      if (val === "双盲") {
        this.isShowBind = true;
      } else {
        this.isShowBind = false;
      }
    },
    goRandomParameter() {
      this.$router.push({
        path: "/random/parameter",
        query: {
          random_type: this.random_type,
          section_type: this.section_type,
          sample_size: this.sample_size,
        },
      });
    },
    add(params) {
      if (!this.isLock) {
        baseSet(params)
          .then((res) => {
            if (res && res.code === 0) {
              setBlind(params.blind_type);
              setRandom(params.random_type);
              setSection(params.section_type);
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.$router.push({
                path: "/random/parameter",
                query: {
                  random_type: this.random_type,
                  section_type: this.section_type,
                  sample_size: this.sample_size,
                },
              });
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((res) => {
            console.log(res.msg);
          });
      } else {
        setBlind(params.blind_type);
        setRandom(params.random_type);
        setSection(params.section_type);
        this.$router.push({
          path: "/random/parameter",
          query: {
            random_type: this.random_type,
            section_type: this.section_type,
            sample_size: this.sample_size,
          },
        });
      }
    },
    validate() {
      if (this.is_need_sample_size) {
        if (!this.sample_size) {
          this.$message({
            message: "请填写样本量",
            type: "warning",
          });
          return false;
        }
        if (!this.sample_size_type) {
          this.$message({
            message: "请选择样本量类型",
            type: "warning",
          });
          return false;
        }
      }
      if (!this.blind_type) {
        this.$message({
          message: "请选择盲态设置",
          type: "warning",
        });
        return false;
      }
      if (this.blind_type === "双盲") {
        if (!this.unblind_user_id) {
          this.$message({
            message: "请选择揭盲负责人",
            type: "warning",
          });
          return false;
        }
      }
      if (!this.experimental_design) {
        this.$message({
          message: "请选择试验设计",
          type: "warning",
        });
        return false;
      }
      if (!this.random_type) {
        this.$message({
          message: "请选择随机类型",
          type: "warning",
        });
        return false;
      }
      if (!this.random_seed) {
        this.$message({
          message: "请填写随机种子",
          type: "warning",
        });
        return false;
      }
      if (this.random_type === "动态随机") {
        if (!this.one_offset) {
          this.$message({
            message: "请填写一级偏差阈值",
            type: "warning",
          });
          return false;
        }
        if (!this.one_probability) {
          this.$message({
            message: "请填写一级修正概率",
            type: "warning",
          });
          return false;
        }
        if (!this.two_offset) {
          this.$message({
            message: "请填写二级偏差阈值",
            type: "warning",
          });
          return false;
        }
        if (!this.two_probability) {
          this.$message({
            message: "请填写二级修正概率",
            type: "warning",
          });
          return false;
        }
      } else {
        if (!this.section_type) {
          this.$message({
            message: "请选择区段使用",
            type: "warning",
          });
          return false;
        }
      }
      return true;
    },
    goParameter() {
      if (this.isLock) {
        this.goRandomParameter();
      } else {
        if (this.validate()) {
          const params = {
            id: this.proId,
            is_need_sample_size: this.is_need_sample_size,
            sample_size_type: this.sample_size_type,
            sample_size: this.is_need_sample_size ? this.sample_size : null,
            blind_type: this.blind_type,
            unblind_user_id: this.unblind_user_id,
            experimental_design: this.experimental_design,
            random_type: this.random_type,
            random_seed: this.random_seed,
            section_type: this.section_type,
            one_offset: this.one_offset,
            one_probability: this.one_probability,
            two_offset: this.two_offset,
            two_probability: this.two_probability,
          };
          this.add(params);
        }
      }
    },
  },
};
</script>

<style scoped>
.setting {
  margin-bottom: 30px;
}

.title {
  font-size: 16px;
  color: #595959;
  font-weight: 500;
  margin-bottom: 10px;
}

.item {
  padding: 10px 0;
}

.detail {
  margin: 0 30px;
}

.right {
  text-align: right;
  line-height: 26px;
}

.circle {
  width: 8px;
  height: 8px;
  background-color: #8eb1ff;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}

.first {
  padding-bottom: 20px;
  border-bottom: 1px dashed #bfbfbf;
}

.two {
  margin-top: 20px;
}

.rights {
  line-height: 26px;
}

.row {
  margin-left: 30px;
}

.threes {
  padding-bottom: 30px;
}

.desc {
  padding-left: 34px;
  font-size: 12px;
  color: #8c8c8c;
}
.setting_box {
  height: 100%;
}

.footer {
  text-align: center;
  margin-top: 200px;
}

.el-button:first-child {
  width: 110px;
  margin-right: 20px;
}
</style>
<style>
input[type="number"] {
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
